var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CookieAlert'),_c('Loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaderVisible),expression:"loaderVisible"}]}),_c('InstantWebsite',{directives:[{name:"show",rawName:"v-show",value:(_vm.iwVisible),expression:"iwVisible"}],staticClass:"page-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }